import React from 'react';
import { useRouteMatch, Switch, Redirect } from 'react-router-dom';
import AuthorizedRoute from 'routes/AuthorizedRoute';
import { DASHBOARD_RESOURCES, DASHBOARD_SCOPES, PAGE_NAMES } from 'constant';

import Create from './submodules/create';
import Edit from './submodules/edit';
import View from './submodules/view';
import List from './submodules/list';

const PlatformFeaturesDashboard: React.FC<{}> = () => {
	const { path } = useRouteMatch();

	return (
		<Switch>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.userSegment}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.userSegment].getPlatformFeatures]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/list`}
				component={List}
				exact
			/>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.userSegment}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.userSegment].updatePlatformFeature]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/edit`}
				component={Edit}
				exact
			/>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.userSegment}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.userSegment].getPlatformFeatures]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/view`}
				component={View}
				exact
			/>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.userSegment}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.userSegment].createPlatformFeature]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/create`}
				component={Create}
				exact
			/>
			<Redirect to={`${path}/list`} />
		</Switch>
	);
};

export default PlatformFeaturesDashboard;
